module.exports = __webpack_public_path__ + "img/57_21.9b9dfcdf.png";